import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiListOl, BiRefresh, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const Konsultasi = () => {
    const [listKonsultasi, setlistKonsultasi] = useState([]);
    const [selectedKonsultasi, setselectedKonsultasi] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            const promise2 = await VedikaService.getKonsultasi(`noregistrasi=${$('#noRegistrasi').text()}`);
            const allPromise = await Promise.all([promise2]);
            if(allPromise[0].data.data.length==0){
                throw new Error('Maaf, Tidak ada data');
            }
            setlistKonsultasi(allPromise[0].data.data);
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }
    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        setselectedKonsultasi(row)
    }

    const loadDtKonsultasi = () => {
        $('#dtKonsultasi').DataTable({
            data: listKonsultasi,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy:true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup></div>),
                },
                {
                    targets: [1],
                    data: 'noorder',
                },
                {
                    targets: [2],
                    data: 'tglorder',
                },
                {
                    targets: [3],
                    data: 'pengonsul',
                },
                {
                    targets: [4],
                    data: 'ruanganasal',
                },
                {
                    targets: [5],
                    data: 'namalengkap',
                },
                {
                    targets: [6],
                    data: 'ruangantujuan',
                },
                {
                    targets: [7],
                    data: 'jeniskonsultasi',
                },
                {
                    targets: [8],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => { [undefined].includes(rowData.status) ? createRoot(td).render('') : createRoot(td).render(rowData.status)},
                },  
            ]
        })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(()=>{
        loadDtKonsultasi();
    },[listKonsultasi])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Konsultasi</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/konsultasi/${$('#norec').val()}`} style={{ textDecoration: 'none',color:'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Table responsive="sm" size="sm" width="100%" id='dtKonsultasi' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>No Order</th>
                                <th>Tgl Order</th>
                                <th>Dokter Pengorder</th>
                                <th>Ruangan Asal</th>
                                <th>Dokter Tujuan</th>
                                <th>Ruangan Tujuan</th>
                                <th>Jenis Konsultasi</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        selectedKonsultasi ? (
                            <>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col md={3}>
                                            <p className='f7'><strong>Nomor Order</strong><br />{selectedKonsultasi.noorder}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Tanggal Order</strong><br />{selectedKonsultasi.tglorder}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Jenis Konsultasi</strong><br />{selectedKonsultasi.jeniskonsultasi}</p>
                                        </Col>
                                        <Col md={3}></Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Dokter Pengorder</strong><br />{selectedKonsultasi.pengonsul}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Ruangan Asal</strong><br />{selectedKonsultasi.ruanganasal}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Dokter Tujuan</strong><br />{selectedKonsultasi.namalengkap}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Ruangan Tujuan</strong><br />{selectedKonsultasi.ruangantujuan}</p>
                                        </Col>
                                    </Row>
                                    </Card.Body>
                                    </Card>
                            <Card className='mt-2'>
                                <Card.Body>
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Masalah</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.masalah}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Pasien dengan diagnosa kerja</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.diagnosakerja}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Ikhtisar Klinik</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.keteranganorder}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Terapi dan Tindakan yang sudah diberikan</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.terapi}</p></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className='mt-2'>
                                <Card.Header>
                                <h5>Pendapat Konsulen</h5>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Pada pemeriksaan didapatkan</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.pemeriksaandidapat}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Diagnosis</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.diagnosis}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Hasil Konsultasi</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.keterangankeperluan}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={2}><h4 className='text-center f7'><strong>Saran</strong></h4></Col>
                                        <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedKonsultasi.saran}</p></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            </>
                        ) : null
                    }
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Konsultasi;